class CartTimerPilgrim extends HTMLElement {
  static storageKey = 'pilgrim-cart-expires-at';
  static lastCountKey = 'pilgrim-cart-last-count';
  static defaultDuration = 1800;

  constructor() {
    super();
    this.duration = parseInt(this.dataset.duration, 10) || CartTimerPilgrim.defaultDuration;
    this.timerEl = this.querySelector('[data-cart-timer-value]');
    this.intervalId = null;
    this.onDrawerOpened = this.onDrawerOpened.bind(this);
  }

  connectedCallback() {
    this.timerEl = this.querySelector('[data-cart-timer-value]');
    CartTimerPilgrim.applyExpiryForCurrentCart(this.duration);
    this.tick();
    this.startInterval();
    document.addEventListener('cartdrawer:opened', this.onDrawerOpened);
  }

  disconnectedCallback() {
    this.stopInterval();
    document.removeEventListener('cartdrawer:opened', this.onDrawerOpened);
  }

  onDrawerOpened() {
    this.tick();
    this.startInterval();
  }

  startInterval() {
    if (this.intervalId) return;
    this.intervalId = window.setInterval(() => this.tick(), 1000);
  }

  stopInterval() {
    if (!this.intervalId) return;
    window.clearInterval(this.intervalId);
    this.intervalId = null;
  }

  static getLastItemCount() {
    return parseInt(window.sessionStorage.getItem(CartTimerPilgrim.lastCountKey) || '0', 10);
  }

  static setLastItemCount(count) {
    window.sessionStorage.setItem(CartTimerPilgrim.lastCountKey, String(count));
  }

  static resetExpiry(duration = CartTimerPilgrim.defaultDuration) {
    window.localStorage.setItem(
      CartTimerPilgrim.storageKey,
      String(Date.now() + duration * 1000)
    );
  }

  static clearExpiry() {
    window.localStorage.removeItem(CartTimerPilgrim.storageKey);
  }

  static ensureExpiry(duration = CartTimerPilgrim.defaultDuration) {
    const stored = parseInt(window.localStorage.getItem(CartTimerPilgrim.storageKey), 10);
    const now = Date.now();

    if (!stored || stored <= now) {
      CartTimerPilgrim.resetExpiry(duration);
    }
  }

  static applyExpiryForCurrentCart(duration = CartTimerPilgrim.defaultDuration) {
    const lastCount = CartTimerPilgrim.getLastItemCount();

    if (lastCount === 0) {
      CartTimerPilgrim.resetExpiry(duration);
    } else {
      CartTimerPilgrim.ensureExpiry(duration);
    }
  }

  static handleCartUpdate(cart) {
    if (!cart) return;

    const itemCount = cart.item_count ?? 0;
    const lastCount = CartTimerPilgrim.getLastItemCount();
    const duration = CartTimerPilgrim.defaultDuration;

    if (itemCount === 0) {
      CartTimerPilgrim.clearExpiry();
      CartTimerPilgrim.setLastItemCount(0);
      CartTimerPilgrim.syncAll();
      return;
    }

    if (lastCount === 0) {
      CartTimerPilgrim.resetExpiry(duration);
    } else {
      CartTimerPilgrim.ensureExpiry(duration);
    }

    CartTimerPilgrim.setLastItemCount(itemCount);
    CartTimerPilgrim.syncAll();
  }

  static getRemainingSeconds() {
    const expiresAt = parseInt(window.localStorage.getItem(CartTimerPilgrim.storageKey), 10);
    if (!expiresAt) return CartTimerPilgrim.defaultDuration;

    return Math.max(0, Math.floor((expiresAt - Date.now()) / 1000));
  }

  tick() {
    if (!this.timerEl) return;

    const remaining = CartTimerPilgrim.getRemainingSeconds();
    const minutes = Math.floor(remaining / 60);
    const seconds = remaining % 60;

    this.timerEl.textContent = `${minutes} min ${String(seconds).padStart(2, '0')} seg.`;

    if (remaining <= 0) {
      CartTimerPilgrim.resetExpiry(this.duration);
    }
  }

  static syncAll() {
    document.querySelectorAll('cart-timer-pilgrim').forEach((timer) => {
      timer.tick();
      timer.startInterval();
    });
  }
}

if (!customElements.get('cart-timer-pilgrim')) {
  customElements.define('cart-timer-pilgrim', CartTimerPilgrim);
}

function onCartUpdatedEvent(event) {
  CartTimerPilgrim.handleCartUpdate(event.detail?.cart);
}

document.addEventListener('cart:updated', onCartUpdatedEvent);
document.addEventListener('cartdrawer:opened', () => CartTimerPilgrim.syncAll());

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    CartTimerPilgrim.handleCartUpdate(event.cart);
  });
}
